<div class="service-client-container">
  <div class="header">
    <h3>Service Client for # OAuth2 client {{ clientId }}</h3>
    <button class="ui tiny button" (click)="backToOAuth2ClientConfig()">OAuth2 Client</button>
  </div>
  <form novalidate [formGroup]="clientFormGroup" class="ui form" (submit)="updateWebhookUrl()">
    <div class="inline fields">
      <div class="field">
        <label>Webhook URL</label>
        <input type="text" formControlName="webhookUrl">
      </div>
      @if (mode === 'register') {
        <app-turnstile size="normal"
          (verified)="onTurnstileTokenVerified($event)"
          (error)="onTurnstileTokenError($event)"
          (expired)="onTurnstileTokenExpired()">
        </app-turnstile>
      }
      <button class="ui primary button" type="submit" [disabled]="!clientFormGroup.dirty || clientFormGroup.invalid">Save Webhook URL</button>
    </div>
  </form>
  @if (client && client.secret) {
    <div class="ui form">
      <div class="inline fields">
        <div class="field">
          <label>Webhook Secret</label>
          <div class="ui icon input">
            <input readonly appCopyOnClick [type]="secretVisibility" [value]="client.secret !== 'rotate' ? client.secret : ''">
            <i class="eye link icon" [ngClass]="{slash: secretVisibility === 'text'}" (click)="toggleSecretVisibility()"></i>
          </div>
        </div>
        <button class="ui button" (click)="rotateSecret()">Regenerate Secret</button>
      </div>
    </div>
  }
  <div class="ui divider"></div>
  @if (client) {
    <div class="ui form">
      <h4>Web Hook Status</h4>
      <div class="inline field">
        <label>Webhook Health</label>
      <div class="ui label" [ngClass]="{
        green: client.webhookHealth === 'Healthy',
        orange: client.webhookHealth === 'Unhealthy',
        red: client.webhookHealth === 'Unreachable'}">{{client.webhookHealth}}</div>
      </div>
      <div class="inline fields">
        <div class="field">
          <label>Consecutive error count</label>
          <input readonly [value]="client.consecutiveFailureCount" />
        </div>
        <button class="ui button" (click)="resetWebhookHealth()">Reset Health Status</button>
      </div>
    </div>
  }
  @if (client && client.lastError) {
    <div class="ui form">
      <h4>Last Error</h4>
      <div class="field">
        <label>Error message</label>
        <textarea [value]="client.lastError.message" ></textarea>
      </div>
      <div class="field">
        <label>code</label>
        <input readonly [value]="client.lastError.code" />
      </div>
      <div class="field">
        <label>requestId</label>
        <input readonly [value]="client.lastError.requestId" />
      </div>
      <div class="field">
        <label>status</label>
        <input readonly [value]="client.lastError.status" />
      </div>
    </div>
  }
  @if (client && client.pendingWebhookEvents && client.pendingWebhookEvents.length > 0) {
    <div class="ui form">
      <h4>Pending Webhook Events</h4>
      <div class="field">
        <label>Events awaiting successful delivery</label>
        <textarea readonly [value]="pendingWebhookEvents" ></textarea>
      </div>
      <button
        type="button"
        class="ui red button"
        [class.loading]="isClearingPendingEvents()"
        [disabled]="isClearingPendingEvents()"
        (click)="clearPendingWebhookEvents()">
        <i class="trash icon" aria-hidden="true"></i>
        Clear Pending Events
      </button>
    </div>
  }
  @if (deleteFormGroup) {
    <form class="ui form" [formGroup]="deleteFormGroup" (submit)="deleteWebhook()">
      <div class="ui divider"></div>
      <h4>Dangerous Area</h4>
      <div class="ui negative  message">
        <header>Delete Service Client</header>
        <p>Input the service client id first {{ deleteConfirmDigitsCount }} characters <strong>{{client.clientId.substring(0, deleteConfirmDigitsCount)}}</strong> to confirm deletion</p>
      </div>
      <div class="field">
        <input type="text" formControlName="confirmText">
      </div>
      <button type="submit" class="ui red button" [disabled]="deleteFormGroup.invalid">Delete Service Client</button>
    </form>
  }
</div>
